import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-566">
      <div className="mb-16" data-id="element-567">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-568">
          Join GigaBrain
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-569">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-570">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-8" data-id="element-571">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-572">
            <div data-id="element-573">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-574">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-575">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-576">
                  Engineering
                </span>
                <span data-id="element-577">•</span>
                <span data-id="element-578">Remote</span>
                <span data-id="element-579">•</span>
                <span data-id="element-580">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-black font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-581">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-582">
            <p data-id="element-583">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at GigaBrain. Our product is
              built on Linux VMs (not containers), and uses a custom coding
              harness that interacts directly with operating system primitives.
            </p>

            <div data-id="element-584">
              <h3 className="text-white font-semibold mb-3" data-id="element-585">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-586">
                <li data-id="element-587">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-588">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-589">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-590">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-591">
              <h3 className="text-white font-semibold mb-3" data-id="element-592">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-593">
                <li data-id="element-594">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-595">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-596">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-597">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-8" data-id="element-598">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-599">
            <div data-id="element-600">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-601">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-602">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-603">
                  Product
                </span>
                <span data-id="element-604">•</span>
                <span data-id="element-605">Remote</span>
                <span data-id="element-606">•</span>
                <span data-id="element-607">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-black font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-608">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-609">
            <p data-id="element-610">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-611">
              <h3 className="text-white font-semibold mb-3" data-id="element-612">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-613">
                <li data-id="element-614">
                  Lead product strategy and execution for the GigaBrain
                  platform.
                </li>
                <li data-id="element-615">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-616">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-617">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-618">
              <h3 className="text-white font-semibold mb-3" data-id="element-619">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-620">
                <li data-id="element-621">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-622">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-623">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-624">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}